import React, { useState } from 'react';
import NavBar from '../Components/NavBar';
import Footer from '../Components/Footer';
import StarIcon from '../Assets/star.svg';
import './EventDetails.css';

// Replace these imports with your own image files:
import HeroImage from '../Assets/event1.svg'; // hero banner (mother & child crafting)
import TicketIcon from '../Assets/safe.svg'; // ticket icon above "Book a Ticket"
import CreditCardIcon from '../Assets/logo.svg'; // credit card logo
import ApplePayIcon from '../Assets/logo.svg'; // Apple Pay logo
import GooglePayIcon from '../Assets/logo.svg'; // Google Pay logo

const expectItems = [
  'Hands-on crafting activities for kids and parents',
  'Guided sessions with friendly instructors',
  'A safe, creative space to build and learn together',
  'Take-home projects you create during the event',
];

const rulesItems = [
  'Children must be accompanied by a parent or guardian',
  'Arrive 10 minutes before the session starts',
  'Respect shared materials and other participants',
  'Follow staff instructions at all times',
];

const materialsItems = [
  'All crafting supplies are provided on site',
  'Comfortable clothing recommended',
  'Optional: bring a water bottle',
  'No outside materials needed unless noted',
];

const EventDetails = () => {
  const [adultTickets, setAdultTickets] = useState(1);
  const [childTickets, setChildTickets] = useState(1);
  const [payment, setPayment] = useState('card');

  const adultPrice = 20;
  const childPrice = 10;
  const total = adultTickets * adultPrice + childTickets * childPrice;

  return (
    <>
      <NavBar active="events" />

      <main className="event-details">
        {/* Hero */}
        <section className="ed-hero">
          <img src={HeroImage} alt="Building Together event" className="ed-hero-img" />
          <div className="ed-hero-overlay">
            <h1 className="ed-hero-title">
              <span className="ed-hero-outline">Building</span>
              <span className="ed-hero-solid">Together</span>
              <img src={StarIcon} alt="" className="ed-hero-star" aria-hidden="true" />
            </h1>
            <div className="ed-hero-dots" aria-hidden="true">
              <span className="active" /><span /><span /><span /><span />
            </div>
          </div>
          <svg className="ed-hero-wave" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
            <path d="M0 20 C200 40, 400 0, 600 20 S1000 40, 1200 20 L1200 40 L0 40 Z" fill="#FFFCDD" />
          </svg>
        </section>

        <div className="ed-content">
          {/* Description */}
          <section className="ed-section ed-hover-block">
            <div className="ed-section-head">
              <h2 className="ed-heading">Description</h2>
              <div className="ed-rating">
                4.7 <img src={StarIcon} alt="" aria-hidden="true" />
              </div>
            </div>
            <p className="ed-text">
              Join us for a heartwarming family crafting experience where parents and children work side by side to create something special. This event is designed to spark creativity, strengthen bonds, and give kids a safe space to express themselves through hands-on activities.
            </p>
            <p className="ed-text">
              Our instructors guide each session with care, ensuring every participant feels welcome and supported. From building simple projects to decorating and personalizing their work, families leave with memories and creations they can be proud of.
            </p>
            <p className="ed-text">
              Perfect for ages 7–13 and their parents, this on-site event combines fun, learning, and quality time in a friendly, supervised environment.
            </p>
          </section>

          <section className="ed-section ed-hover-block">
            <h2 className="ed-heading">What to expect</h2>
            <ul className="ed-list">
              {expectItems.map((item) => (
                <li key={item}><img src={StarIcon} alt="" aria-hidden="true" />{item}</li>
              ))}
            </ul>
          </section>

          <section className="ed-section ed-hover-block">
            <h2 className="ed-heading">Rules</h2>
            <ul className="ed-list">
              {rulesItems.map((item) => (
                <li key={item}><img src={StarIcon} alt="" aria-hidden="true" />{item}</li>
              ))}
            </ul>
          </section>

          <section className="ed-section ed-hover-block">
            <h2 className="ed-heading">Materials needed</h2>
            <ul className="ed-list">
              {materialsItems.map((item) => (
                <li key={item}><img src={StarIcon} alt="" aria-hidden="true" />{item}</li>
              ))}
            </ul>
          </section>

          {/* Book a Ticket */}
          <section className="ed-section ed-book ed-hover-block">
            <div className="ed-book-head">
              <img src={TicketIcon} alt="" className="ed-ticket-icon" aria-hidden="true" />
              <h2 className="ed-heading">Book a Ticket</h2>
            </div>

            <form className="ed-form" onSubmit={(e) => e.preventDefault()}>
              <div className="ed-form-grid">
                <label className="ed-field">
                  Full Name
                  <input type="text" placeholder="Enter full name" />
                </label>
                <label className="ed-field">
                  Child Name
                  <input type="text" placeholder="Enter child name" />
                </label>
                <label className="ed-field">
                  Phone Number
                  <input type="tel" placeholder="Enter phone number" />
                </label>
                <label className="ed-field">
                  Email Address
                  <input type="email" placeholder="Enter email address" />
                </label>
              </div>

              <div className="ed-tickets">
                <div className="ed-ticket-row">
                  <span>Adult Tickets</span>
                  <div className="ed-qty">
                    <button type="button" onClick={() => setAdultTickets(Math.max(0, adultTickets - 1))}>−</button>
                    <span>{adultTickets}</span>
                    <button type="button" onClick={() => setAdultTickets(adultTickets + 1)}>+</button>
                  </div>
                </div>
                <div className="ed-ticket-row">
                  <span>Child Tickets</span>
                  <div className="ed-qty">
                    <button type="button" onClick={() => setChildTickets(Math.max(0, childTickets - 1))}>−</button>
                    <span>{childTickets}</span>
                    <button type="button" onClick={() => setChildTickets(childTickets + 1)}>+</button>
                  </div>
                </div>
              </div>

              <p className="ed-total">Total Amount: <strong>{total} egp</strong></p>

              <div className="ed-payments">
                {[
                  { id: 'card', label: 'Credit card', icon: CreditCardIcon },
                  { id: 'apple', label: 'Apple Pay', icon: ApplePayIcon },
                  { id: 'google', label: 'Google Pay', icon: GooglePayIcon },
                ].map(({ id, label, icon }) => (
                  <label key={id} className={`ed-payment ${payment === id ? 'selected' : ''}`}>
                    <img src={icon} alt="" aria-hidden="true" />
                    <span>{label}</span>
                    <input
                      type="radio"
                      name="payment"
                      value={id}
                      checked={payment === id}
                      onChange={() => setPayment(id)}
                    />
                  </label>
                ))}
              </div>

              <button type="submit" className="ed-book-btn">Book now</button>
            </form>
          </section>

          {/* Review */}
          <section className="ed-section ed-hover-block">
            <h2 className="ed-heading">Review</h2>
            <div className="ed-review-stars" aria-label="5 out of 5 stars">
              {[...Array(5)].map((_, i) => (
                <span key={i} className="ed-big-star">★</span>
              ))}
            </div>
          </section>

          {/* Comments */}
          <section className="ed-section ed-hover-block">
            <h2 className="ed-heading">Comments</h2>
            <input type="text" className="ed-comment-input" placeholder="Write here..." />
          </section>
        </div>
      </main>

      <Footer />
    </>
  );
};

export default EventDetails;
